import { DTOCodeSnapshotScannerType } from "../../dto/design-systems/code-snapshots";
import { z } from "zod";
export const DTOCodeSnapshotUploadInitScannerType = DTOCodeSnapshotScannerType;
export const DTOCodeSnapshotUploadInitPayload = z.object({
    archiveChecksum: z.string(),
    archiveName: z.string(),
    archiveSize: z.number(),
    designSystemId: z.string(),
    repoId: z.string(),
    repoName: z.string(),
    repoPackageName: z.string(),
    scannerType: DTOCodeSnapshotUploadInitScannerType,
});
export const DTOCodeSnapshotFinalizePayload = z.object({}).optional();
export const DTOCodeSnapshotStartProcessingRunPayload = z.object({
    designSystemId: z.string(),
});
